import { useContext } from 'react';
import { LabsContext } from '../context/LabsContext';

export const useLabs = () => {
  const context = useContext(LabsContext);
  if (!context) {
    throw new Error('useLabs debe ser usado dentro de LabsProvider');
  }
  return context;
};

export const useLabsData = () => {
  const { routes, loading, error } = useLabs();
  return { routes, loading, error };
};

export const useUserLabsProgress = () => {
  const { userProgress, loading } = useLabs();
  return { userProgress, loading };
};

export const useLabCompletion = () => {
  const { completeLevel, fetchUserProgress } = useLabs();
  return { completeLevel, fetchUserProgress };
};

export const useHints = () => {
  const { getHint } = useLabs();
  return { getHint };
};

export const useUserStats = () => {
  const { userProgress, userAchievements } = useLabs();

  const getTotalXP = () => {
    return Object.values(userProgress).reduce((total, ruta) => {
      return total + (ruta.xp_total || 0);
    }, 0);
  };

  const getCurrentRank = () => {
    const totalXP = getTotalXP();
    const ranks = [
      { name: 'Principiante', minXP: 0 },
      { name: 'Novato', minXP: 500 },
      { name: 'Intermedio', minXP: 1500 },
      { name: 'Avanzado', minXP: 3000 },
      { name: 'Experto', minXP: 4500 },
      { name: 'Maestro', minXP: 5000 },
    ];
    return ranks.reduce((current, rank) => 
      totalXP >= rank.minXP ? rank : current
    );
  };

  const getCompletedLevels = () => {
    return Object.values(userProgress).reduce((total, ruta) => {
      return total + (ruta.niveles?.filter(n => n.completado).length || 0);
    }, 0);
  };

  const getCompetencies = () => {
    const competencies = new Set();
    Object.values(userProgress).forEach(ruta => {
      ruta.niveles?.forEach(nivel => {
        if (nivel.completado) {
          nivel.competencias_aprendidas?.forEach(comp => competencies.add(comp));
        }
      });
    });
    return Array.from(competencies);
  };

  return {
    totalXP: getTotalXP(),
    currentRank: getCurrentRank(),
    completedLevels: getCompletedLevels(),
    competencies: getCompetencies(),
    achievements: userAchievements,
  };
};
